export default "__VITE_ASSET__d1e9c0a2__"